/**
 * Surinamese dollar.
 */
export var SRD = {
  code: 'SRD',
  base: 10,
  exponent: 2
};